import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { IncomeNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addIncome = (state: SyfoAppState, action: PayloadAction<IncomeNode>) => {
  if (state.currentVault) {
    state.currentVault.data.incomes.push(action.payload);
  }
};

export const updateIncome = (state: SyfoAppState, action: PayloadAction<{ id: string; income: Partial<IncomeNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.incomes, action.payload.id, action.payload.income);
  }
};

export const removeIncome = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.incomes = state.currentVault.data.incomes.filter(i => i.id !== action.payload);
  }
};